import { IUpdateCargoUseCase } from "../../../presentation/useCases/update/update_cargo_use_case";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * UpdateCargoUseCase
 */

export class UpdateCargoUseCase implements IUpdateCargoUseCase {
  constructor(private readonly repository: IRhRepository) { }

  async updateCargo(
    idCargo: number,
    ativo: number,
    descricao: string,
    atribuicoes: string,
    escolaridade: string,
    experiencia: string,
    qualificacoes: string,
    treinamentos: number[],
    habilidades: number[],
  ): Promise<void> {
    await this.repository.updateCargo(
      idCargo,
      ativo,
      atribuicoes,
      descricao,
      escolaridade,
      experiencia,
      qualificacoes,
      treinamentos,
      habilidades,
    );
  }
}
